import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'Home',
			component: Home,
			meta: {
				title: '让每个决策都有数据支撑'
			}
		},
		{
			path: '/voucher',
			name: 'Voucher',
			component: () => import('./views/voucher/Index'),
			meta: {
				title: '凭证列表'
			}
		},
		{
			path: '/voucher/form/:voucherId(\\d+)?',
			name: 'VoucherForm',
			component: () => import('./views/voucher/VoucherForm'),
			props: true,
			meta: {
				title: '凭证信息'
			}
		},
		{
			path: '/check-out',
			name: 'CheckOut',
			component: () => import('./views/checkout/Index'),
			children: [
				{
					path: 'list',
					name: 'CheckList',
					component: () => import('./views/checkout/CheckList'),
					meta: {
						title: '结账'
					}
				},
				{
					path: 'un-check',
					name: 'UnCheckOut',
					component: () => import('./views/checkout/UnCheckOut'),
					meta: {
						title: '反结账'
					}
				}, {
					path: 'carry-forward/:checkYear(\\d+)/:checkMonth(\\d+)',
					name: 'CarryForward',
					props: true,
					component: () => import('./views/checkout/CarryForward'),
					meta: {
						title: '月末结转'
					}
				}, {
					path: 'check/:checkYear(\\d+)/:checkMonth(\\d+)',
					name: 'Check',
					props: true,
					component: () => import('./views/checkout/Check'),
					meta: {
						title: '检查'
					}
				}
			]
		},
		{
			path: '/account',
			name: 'Account',
			component: () => import('./views/setting/Account'),
			meta: {
				title: '账套'
			}
		},
		{
			path: '/subject',
			name: 'Subject',
			component: () => import('./views/setting/Subject'),
			meta: {
				title: '科目'
			}
		},
		{
			path: '/initial',
			name: 'Initial',
			component: () => import('./views/setting/Initial'),
			meta: {
				title: '期初'
			}
		},
		{
			path: '/voucher-word',
			name: 'VoucherWord',
			component: () => import('./views/setting/VoucherWord'),
			meta: {
				title: '凭证字'
			}
		},
		{
			path: '/currency',
			name: 'Currency',
			component: () => import('./views/setting/Currency'),
			meta: {
				title: '币别'
			}
		},
		{
			path: '/assisting-accounting',
			name: 'AssistingAccounting',
			component: () => import('./views/setting/AssistingAccounting'),
			meta: {
				title: '辅助核算'
			},
			children: [
				{
					path: 'accounting-category',
					name: 'AccountingCategory',
					component: () => import('./views/setting/AssistingAccounting/AccountingCategory'),
					meta: {
						title: '辅助核算类别'
					}
				},
				{
					path: 'custom/:id(\\d+)',
					name: 'CategoryCustom',
					component: () => import('./views/setting/AssistingAccounting/CategoryCustom'),
					props: true,
					meta: {
						title: '自定类别'
					}
				}
			]
		},
		{
			path: '/template',
			component: () => import('./views/setting/template/Index'),
			meta: {
				title: '模板管理'
			},
			children: [{
				path: 'manager',
				name: 'TemplateManager',
				component: () => import('./views/setting/template/TemplateManager'),
				meta: {
					title: '模板管理'
				}
			}, {
				path: 'design/:templateId(\\d+)?',
				name: 'TemplateDesign',
				component: () => import('./views/setting/template/TemplateDesign'),
				props: true,
				meta: {
					title: '模板设计'
				}
			}]
		},
		{
			path: '/assets-type',
			name: 'AssetsType',
			component: () => import('./views/assets/AssetsType'),
			meta: { title: '资产类别' }
		},
		{
			path: '/assets',
			name: 'Assets',
			component: () => import('./views/assets/Assets'),
			meta: { title: '资产管理' }
		},
		{
			path: '/assets-depreciation',
			name: 'AssetsDepreciation',
			component: () => import('./views/assets/AssetsDepreciation'),
			meta: { title: '折旧明细表' }
		},
		{
			path: '/assets-summary',
			name: 'AssetsSummary',
			component: () => import('./views/assets/AssetsSummary'),
			meta: { title: '资产汇总' }
		},
		{
			path: '/assets-check',
			name: 'AssetsCheck',
			component: () => import('./views/assets/AssetsCheck'),
			meta: { title: '资产对账' }
		},
		{
			path: '/cashier-journal',
			name: 'CashierJournal',
			component: () => import('./views/funds/CashierJournal'),
			meta: { title: '日记账' }
		},
		{
			path: '/cashier-transfer',
			name: 'CashierTransfer',
			component: () => import('./views/funds/CashierTransfer'),
			meta: { title: '内部转账' }
		},
		{
			path: '/cashier-report',
			name: 'CashierReport',
			component: () => import('./views/funds/CashierReport'),
			meta: { title: '资金报表' }
		},
		{
			path: '/cashier-check',
			name: 'CashierCheck',
			component: () => import('./views/funds/CashierCheck'),
			meta: { title: '核对总账' }
		},
		{
			path: '/cashier-io-type',
			name: 'CashierIoType',
			component: () => import('./views/funds/CashierIoType'),
			meta: { title: '收支类别' }
		},
		{
			path: '/cashier-account',
			name: 'CashierAccount',
			component: () => import('./views/funds/CashierAccount'),
			meta: { title: '账户设置' }
		},
		{
			path: '/invoice-output',
			name: 'OutputInvoice',
			component: () => import('./views/invoice/OutputInvoice'),
			meta: { title: '销项发票' }
		},
		{
			path: '/invoice-income',
			name: 'IncomeInvoice',
			component: () => import('./views/invoice/IncomeInvoice'),
			meta: { title: '进项发票' }
		},
		{
			path: '/invoice-expense',
			name: 'Expense',
			component: () => import('./views/invoice/Expense'),
			meta: { title: '费用单据' }
		},
		{
			path: '/invoice-non-income',
			name: 'NonIncome',
			component: () => import('./views/invoice/NonIncome'),
			meta: { title: '无票收入' }
		},
		{
			path: '/invoice-smart',
			name: 'IntelligentInvoicing',
			component: () => import('./views/invoice/IntelligentInvoicing'),
			meta: { title: '智能开票' }
		},
		{
			path: '/salary-info',
			name: 'SalaryInfo',
			component: () => import('./views/salary/SalaryInfo'),
			meta: { title: '工资信息' }
		},
		{
			path: '/salary-employee',
			name: 'SalaryEmployee',
			component: () => import('./views/salary/SalaryEmployee'),
			meta: { title: '员工信息' }
		},
		{
			path: '/salary-insurance',
			name: 'SalaryInsurance',
			component: () => import('./views/salary/SalaryInsurance'),
			meta: { title: '五险一金设置' }
		},
		{
			path: '/salary-tax',
			name: 'SalaryTaxDeclare',
			component: () => import('./views/salary/SalaryTaxDeclare'),
			meta: { title: '个税申报' }
		},
		{
			path: '/permission-setting',
			name: 'PermissionSetting',
			component: () => import('./views/setting/PermissionSetting'),
			meta: {
				title: '权限设置'
			}
		},
		{
			path: '/personal',
			name: 'Personal',
			component: () => import('./views/personal/Index'),
			meta: {
				title: '个人设置'
			},
			children: [
				{
					path: 'personal-setting',
					name: 'PersonalSetting',
					component: () => import('./views/personal/PersonalSetting'),
					meta: {
						title: '个人设置'
					}
				},
				{
					path: 'change-password',
					name: 'ChangePassword',
					component: () => import('./views/personal/ChangePassword'),
					meta: {
						title: '修改密码'
					}
				},
				{
					path: 'change-phone-number',
					name: 'ChangePhoneNumber',
					component: () => import('./views/personal/ChangePhoneNumber'),
					meta: {
						title: '修改手机'
					}
				},
				{
					path: 'binding-webchat',
					name: 'BindingWebchat',
					component: () => import('./views/personal/BindingWebchat'),
					meta: {
						title: '绑定微信'
					}
				}
			]
		},
		{
			path: '/account-book/detailed',
			name: 'DetailedAccounts',
			component: () => import('./views/accountbook/DetailedAccounts'),
			meta: {
				title: '明细账'
			}
		},
		{
			path: '/account-book/general-ledger',
			name: 'GeneralLedger',
			component: () => import('./views/accountbook/GeneralLedger'),
			meta: {
				title: '总账'
			}
		},
		{
			path: '/account-book/subject-balance',
			name: 'SubjectBalance',
			component: () => import('./views/accountbook/SubjectBalance'),
			meta: {
				title: '科目余额'
			}
		},
		{
			path: '/account-book/subject-summary',
			name: 'SubjectSummary',
			component: () => import('./views/accountbook/SubjectSummary'),
			meta: {
				title: '科目汇总'
			}
		},
		{
			path: '/account-book/auxiliary-accounting-balance',
			name: 'AuxiliaryAccountingBalance',
			component: () => import('./views/accountbook/AuxiliaryAccountingBalance'),
			meta: {
				title: '辅助核算余额'
			}
		},
		{
			path: '/account-book/auxiliary-accounting-detail',
			name: 'AuxiliaryAccountingDetail',
			component: () => import('./views/accountbook/AuxiliaryAccountingDetail'),
			meta: {
				title: '辅助核算明细账'
			}
		},
		{
			path: '/account-book/time-series',
			name: 'TimeSeries',
			component: () => import('./views/accountbook/TimeSeries'),
			meta: {
				title: '序时账'
			}
		},
		{
			path: '/account-book/multi-column-ledger',
			name: 'MultiColumnLedger',
			component: () => import('./views/accountbook/MultiColumnLedger'),
			meta: {
				title: '多栏账'
			}
		},
		{
			path: '/account-book/age-analysis',
			name: 'AgeAnalysis',
			component: () => import('./views/accountbook/AgeAnalysis'),
			meta: {
				title: '账龄分析表'
			}
		},
		{
			path: '/report',
			name: 'ReportList',
			component: () => import('./views/report/ReportList'),
			meta: {
				title: '报表'
			}
		},
		{
			path: '/report/view/:reportId(\\d+)',
			name: 'ReportView',
			props: true,
			component: () => import('./views/report/ReportView'),
			meta: {
				title: '报表数据'
			}
		},
		{
			path: '/report/template',
			name: 'ReportTemplate',
			component: () => import('./views/report/template/TemplateList'),
			meta: {
				title: '报表模板'
			}
		},
		{
			path: '/report/template/form/:templateId(\\d+)',
			name: 'TemplateForm',
			props: true,
			component: () => import('./views/report/template/TemplateForm'),
			meta: {
				title: '模板编辑'
			}
		},
		{
			path: '/bi-report',
			name: 'BiReportList',
			component: () => import('./views/report/BiReportList'),
			meta: {
				title: '自定义报表'
			}
		},
		{
			path: '/report/expense-detail',
			name: 'ExpenseDetailReport',
			component: () => import('./views/report/ExpenseDetailReport'),
			meta: {
				title: '费用明细表'
			}
		},
		{
			path: '/report/profit-statement-quarter',
			name: 'ProfitStatementQuarter',
			component: () => import('./views/report/ProfitStatementQuarter'),
			meta: {
				title: '利润表季报'
			}
		},
		{
			path: '/report/cash-flow-statement-quarter',
			name: 'CashFlowStatementQuarter',
			component: () => import('./views/report/CashFlowStatementQuarter'),
			meta: {
				title: '现金流量表季报'
			}
		},
		{
			path: '/report/business-activity-statement',
			name: 'BusinessActivityStatement',
			component: () => import('./views/report/BusinessActivityStatement'),
			meta: {
				title: '业务活动表'
			}
		},
		{
			path: '/report/business-activity-statement-quarter',
			name: 'BusinessActivityStatementQuarter',
			component: () => import('./views/report/BusinessActivityStatementQuarter'),
			meta: {
				title: '业务活动表季报'
			}
		},
		{
			path: '/report/balance-statement',
			name: 'BalanceStatement',
			component: () => import('./views/report/BalanceStatement'),
			meta: {
				title: '资产负债表月报'
			}
		},
		{
			path: '/report/profit-statement',
			name: 'ProfitStatement',
			component: () => import('./views/report/ProfitStatement'),
			meta: {
				title: '利润表月报'
			}
		},
		{
			path: '/report/cash-flow-statement',
			name: 'CashFlowStatement',
			component: () => import('./views/report/CashFlowStatement'),
			meta: {
				title: '现金流量表月报'
			}
		},
		{
			path: '/bi-report/design/:reportId(\\d+)',
			name: 'BiReportDesigner',
			props: true,
			component: () => import('./views/report/BiReportDesigner'),
			meta: {
				title: '报表设计器'
			}
		},
			{
			path: '/tripartite',
			name: 'Tripartite',
			component: () => import('./views/tripartite/TripartiteIndex'),
			meta: {
				title: '业务凭证'
			}
		},
		{
			path: '/declare',
			name: 'Declare',
			component: () => import('./views/declare/DeclareIndex'),
			meta: {
				title: '企业税申报'
			}
		},
 		{
			path: '/setting/sync',
			name: 'SyncIndex',
			component: () => import('./views/setting/SyncIndex'),
			meta: { title: '旧账同步' }
		},
		{
			path: '/setting/backup',
			name: 'BackupIndex',
			component: () => import('./views/setting/BackupIndex'),
			meta: { title: '备份恢复' }
		},
		{
			path: '/setting/audit-export',
			name: 'AuditExportIndex',
			component: () => import('./views/setting/AuditExportIndex'),
			meta: { title: '审计数据' }
		},
		{
			path: '/setting/audit-log',
			name: 'AuditLogIndex',
			component: () => import('./views/setting/AuditLogIndex'),
			meta: { title: '审计日志' }
		},
		{
			path: '/merchant',
			name: 'Merchant',
			component: () => import('./views/merchant/MerchantIndex'),
			meta: { title: '商户管理' }
		},
	]
});
